import React, { useCallback, useMemo, useState, useRef } from 'react'

import { Report, Modal } from '~/components';
import {
    RadioGroup
} from '~/components/Form';
import {
    CircularProgress,
} from '@material-ui/core';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { SelectComplete } from '~/componentslocal';
import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';
import api from '~/services/api';
import qs from 'querystring';

import GraphicAbastecimento from './GraphicAbastecimento';
import GraphicAbastecimentoDiaNoite from './GraphicAbastecimentoDiaNoite';
import { TypeFilters } from '~/components';


export default function DlgGraficoAbastecimento() {

    const [open, setOpen] = useState(true);
    const reference = useRef(null);
    const modalRef = useRef(null);

    const [loading, setLoading] = useState(false)
    const [graphicType, setGraphicType] = useState('')

    const filterRef = useRef(null);

    const [post, setPost] = useState('')
    const [dataObjto, setDataObjto] = useState({});


    const [tipoTypeFilters, setTipoTypeFilters] = useState(0)
    const [dataHoraInicial, setDataHoraInicial] = useState('')
    const [dataHoraFinal, setDataHoraFinal] = useState('')




    const handleGetData = useCallback((value) => {
        setTipoTypeFilters(value.tipo)
        if (value.tipo === 1) {
            setDataHoraInicial(value.datahora_inicio)
            setDataHoraFinal(value.datahora_fim)
        } else if (value.tipo == 5) {

            setDataHoraInicial(value.turno_inicio ? value.turno_inicio.turn_datahora_ini : value.data_inicio_turno + ' 00:00:00')
            setDataHoraFinal(value.turno_fim ? value.turno_fim.turn_datahora_fim : value.data_fim_turno + ' 23:59:59')

        } else if (value.tipo == 2) {
            setDataHoraInicial(value.data_inicio + ' 00:00:00')
            setDataHoraFinal(value.data_fim + ' 23:59:59')
        }
        setDataObjto(value);
    }, [filterRef]);

    const schemaDataHora = Yup.object().shape({
        datahora_inicio: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        datahora_fim: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
    });

    const schemaOnlyDataTurno = Yup.object().shape({
        data_inicio_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        data_fim_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        posto: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
    });

    const handleValidate = useCallback(async (data) => {
        try {

            if (tipoTypeFilters == 1) {
                await schemaDataHora.validate({ datahora_inicio: dataHoraInicial, datahora_fim: dataHoraFinal }, {
                    abortEarly: false,
                });
            } else if (tipoTypeFilters == 5) {
                await schemaOnlyDataTurno.validate({ data_inicio_turno: dataHoraInicial, data_fim_turno: dataHoraFinal, posto: post.post_cod_posto }, {
                    abortEarly: false,
                });
            }
            filterRef.current.setErrors({})

        } catch (err) {
            console.log(err)
            const form = {};

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    form[error.path] = error.message.replace(`${error.path} `, '');
                });
                filterRef.current.setErrors(form);

            }
            throw err;
        }
    }, [dataObjto, dataHoraInicial, dataHoraFinal, filterRef, tipoTypeFilters, post])

    const handleMountGraphic = useCallback(async (data) => {
        setLoading(true)

        let params = data;
        const response = await api.get('graficoabastecimento', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        setLoading(false)

        handleShowGraphic(response.data)
    }, [])

    const handleShowGraphic = useCallback((data) => {
        modalRef.current.handleOpenModal({ data });
    }, [modalRef]);

    const modalButtons = useMemo(() => [{
        label: 'Fechar',
        color: 'secondary',
        callback: () => modalRef.current.handleCloseModal()
    }], [])


    const handleSerializeForm = useCallback((param) => {
        setGraphicType(param.tipo)

        const serializeObject = {
            ...param,
            codPosto: post.post_cod_posto ? post.post_cod_posto : '',
            postostr: post.post_desc ? post.post_desc : '',
            dataIni: dataHoraInicial,
            dataFim: dataHoraFinal,
            idtarefapath: "dlgGraficoAbastecimento.swf",
        }


        handleMountGraphic(serializeObject)



        return undefined

    }, [dataHoraInicial, dataHoraFinal, post])




    return (
        <>
            <Report
                ref={reference}
                open={open}
                onClose={() => setOpen(false)}
                title="Gráfico Consumo de Combustível no Periodo por Data"
                relatorio="graficoabastecimento"
                validate={handleValidate}
                serialize={(param) => handleSerializeForm(param)}
            >

                <SelectComplete
                    name="posto"
                    title="Posto"
                    label="post_desc"
                    unique="post_cod_posto"
                    url="usuarioposto"
                    getValue={(value) => {
                        setPost(value);
                    }}
                />

                <TypeFilters
                    ref={filterRef}
                    initials={{
                        tipo: 1,
                        datahora_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy HH:mm:ss'),
                        datahora_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy HH:mm:ss')
                    }}
                    name="filtroData"
                    numberOfYears={9}
                    options={[
                        { label: t('s.geral.filtro.periododatahora'), value: 1 },
                        { label: t('s.geral.filtro.turno'), value: 5 },
                    ]}
                    onCallback={handleGetData}
                    initialURL="/turno/getturnosinicio"
                    finalURL="/turno/getturnosfim"
                    code={post.post_cod_posto}
                />


                <RadioGroup
                    name="tipo"
                    label="Tipo"
                    options={[
                        { label: 'Geral', value: "1" },
                        { label: 'Dia/Noite', value: "2" },
                    ]}
                    defaultValue="1"
                    serialize={(value) => Number(value)}
                    row
                />

                {loading && <CircularProgress
                    size={20}
                    color="primary"
                    style={{ marginLeft: 'calc(50% - 20px)' }}
                />}


            </Report>

            <Modal
                disableBackdropClick
                disableEscapeKeyDown
                ref={modalRef}
                title="Apuração de Inventário"
                maxWidth="lg"
                component={graphicType == 1 ? GraphicAbastecimento : GraphicAbastecimentoDiaNoite}
                actions={modalButtons}
            />
        </>

    )
}
